import * as React from 'react';

// @ts-expect-error
export const RouteContext: React.Context<{
    isEmbedded: boolean;
}> = React.createContext({isEmbedded: true});
